"use client"

import React from "react";
import Image from "next/image";
import { FormattedMessage } from "react-intl";
import Link from "next/link";
import {
  FaInstagram,
  FaWhatsapp,
  FaFacebook,
  FaLinkedin
} from "react-icons/fa6";

import PAGES, { menuItems } from "@/constants/pages";

import LogoFull from "@/assets/images/logo/logo_full_black.png";

const socialContent = [
  {
    icon: <FaInstagram style={{ fontSize: 25, color: "#ffffff" }} />,
    link: "https://www.instagram.com/downfor.life/",
    label: "Open the website instagram profile",
  },
  {
    icon: <FaFacebook style={{ fontSize: 25, color: "#ffffff" }} />,
    link: "https://www.facebook.com/downfor.webapp/",
    label: "Open the website instagram profile",
  },
  {
    icon: <FaLinkedin style={{ fontSize: 25, color: "#ffffff" }} />,
    link: "https://www.linkedin.com/company/downfor",
    label: "Open the website instagram profile",
  },
  {
    icon: <FaWhatsapp style={{ fontSize: 25, color: "#ffffff" }} />,
    link: "https://wa.me/message/AFY5MLYSZMFIG1",
    label: "Open the website whatsapp",
  }
];

const Footer = () => (
  <>
    <div className="bg-[#F8FAFB] pt-[95px] pb-[16px] dark:bg-[#15182A]">
      <div className="container max-w-[1390px]">
        <div className="flex flex-wrap -mx-4">
          <div className="w-full px-4 lg:w-4/12 xl:w-5/12">
            <div className="mb-11 max-w-[320px]">
              <Link
                href="/"
                alt="Link to home page"
                title="Link to home page"
                className="inline-block mb-8"
              >
                <Image
                  src={LogoFull}
                  alt="The Downfor Logo"
                  title="Downfor Logo"
                  className="block max-w-[150px]"
                />
              </Link>
              <p className="text-base text-body">
                <FormattedMessage
                  id="home-page-footer-logo-description"
                />
              </p>
            </div>
          </div>

          <div className="w-full px-4 lg:w-8/12 xl:w-7/12">
            <div className="flex flex-wrap justify-end -mx-4">
              <div className="w-full px-4 sm:w-1/2 md:w-2/12 lg:w-2/12">
                <div className="mb-11">
                  <h3 className="mb-8 text-[22px] font-bold text-black dark:text-white">
                    <FormattedMessage
                      id="home-page-footer-menu-title"
                    />
                  </h3>

                  <ul className="space-y-[10px]">
                    {menuItems?.map((item, index) => (
                      <li
                        key={index}
                      >
                        <a
                          href={item?.href}
                          title={`Link to ${item?.href}`}
                          className="inline-block text-base text-body hover:text-primary"
                        >
                          <FormattedMessage id={item?.textKey} />
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="w-full px-4 sm:w-1/2 md:w-3/12 lg:w-3/12">
                <div className="mb-11">
                  <h3 className="mb-8 text-[22px] font-bold text-black dark:text-white">
                    <FormattedMessage
                      id="home-page-footer-resources-title"
                    />
                  </h3>

                  <ul className="space-y-[10px]">
                    <li>
                      <a
                        href={PAGES.privacyPolicy}
                        alt="Link to Privacy Policy page"
                        title="Link to Privacy Policy page"
                        className="inline-block text-base text-body text-primary hover:text-primary/70 font-bold"
                      >
                        <FormattedMessage
                          id="home-page-footer-privacy-link-text"
                        />
                      </a>
                    </li>

                    <li>
                      <a
                        href={PAGES.termsOfService}
                        title="Link to TermsvOf Service page"
                        alt="Link to Terms Of Service page"
                        className="inline-block text-base text-body text-primary hover:text-primary/70 font-bold"
                      >
                        <FormattedMessage
                          id="home-page-footer-terms-link-text"
                        />
                      </a>
                    </li>

                    <li>
                      <a
                        href={PAGES.cookiesPolicy}
                        title="Link to Cookies Policy page"
                        alt="Link to Cookies Policy page"
                        className="inline-block text-base text-body text-primary hover:text-primary/70 font-bold"
                      >
                        <FormattedMessage
                          id="home-page-footer-cookies-link-text"
                        />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="w-full px-4 sm:w-1/2 md:w-4/12 lg:w-4/12">
                <div className="mb-11">
                  <h3 className="mb-8 text-[22px] font-bold text-black dark:text-white">
                    <FormattedMessage
                      id="home-page-footer-tutorial-title"
                    />
                  </h3>

                  <ul className="space-y-[10px]">
                    <li>
                      <a
                        href="https://blog.downfor.life/posts/how-to-create-a-website-for-free-using-downfor"
                        className="inline-block text-base text-body hover:text-primary"
                        target="_blank"
                        alt={`Link to the post "How to Create a Website for Free Using Downfor"`}
                        title={`Link to the post "How to Create a Website for Free Using Downfor"`}
                      >
                        How to Create a Website for Free Using Downfor
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://blog.downfor.life/posts/how-to-add-a-link-in-bio-on-socials"
                        className="inline-block text-base text-body hover:text-primary"
                        target="_blank"
                        alt={`Link to the post "How to Create a Link in Bio for Instagram, TikTok, and Facebook"`}
                        title={`Link to the post "How to Create a Link in Bio for Instagram, TikTok, and Facebook"`}
                      >
                        How to Create a Link in Bio for Instagram, TikTok, and Facebook
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://blog.downfor.life/posts/how-to-create-a-minisite-for-your-event-in-5-easy-steps"
                        className="inline-block text-base text-body hover:text-primary"
                        target="_blank"
                        alt={`Link to the post "How to Create a Minisite for Your Event in 5 Easy Steps"`}
                        title={`Link to the post "How to Create a Minisite for Your Event in 5 Easy Steps"`}
                      >
                        How to Create a Minisite for Your Event in 5 Easy Steps
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-primary py-7 dark:bg-black">
      <div className="container max-w-[1390px]">
        <div className="flex flex-wrap -mx-3">
          <div className="order-last w-full px-3 lg:order-first lg:w-1/2">
            <p className="mt-4 text-base text-center text-white lg:mt-0 lg:text-left">
              &copy;
              {" "}
              Copyright @{new Date().getFullYear()}{" "}
              <a
                href="https://www.downfor.life"
                target="_blank"
                rel="noreferrer"
                title="Downfor home page"
              >
                Downfor.life
              </a>
            </p>
          </div>

          <div className="w-full px-3 md:w-1/2 lg:w-1/2">
            <div className="flex items-center justify-center mb-4 space-x-5 md:mb-0 md:justify-start lg:justify-end">
              {socialContent.map((val, index) => (
                <a
                  key={index}
                  className="text-white opacity-70 hover:opacity-100"
                  name={val.label}
                  href={val.link}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={val.label}
                  title={`Downfor link to ${val.label}`}
                >
                  {val.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default Footer;